import { useSelector } from "react-redux";
import { getIsInDetachMode } from "src/duck/selectors";
import environment, { getAppValue } from "src/utils/environment";
import { Lottie } from "src/components/Lottie";
import { useParentStation } from "src/modules/parent-station/ParentStation/Context";

const { isBarkio } = environment;
export default function MotionIndicator({ mode }) {
  const parentStation = useParentStation();
  const isInDetachMode = useSelector(getIsInDetachMode);
  const { showTilesView } = parentStation;

  return (
    <Lottie
      sx={{
        ...(isBarkio && { "& .Warning": { fill: "warningBase" } }),
        ...(isInDetachMode
          ? { height: "11vmin !important" }
          : {
              "@media (max-width: 680px)": {
                height: "20px !important"
              },
              "@media (max-width: 1200px)": {
                height: "28px !important"
              },
              "@media (min-width: 1200px)": {
                height: "32px !important"
              }
            }),
        ...(showTilesView && {
          "@media (max-width: 680px)": {
            height: "16px !important"
          },
          "@media (max-width: 1200px)": {
            height: "20px !important"
          },
          "@media (min-width: 1200px)": {
            height: "28px !important"
          }
        })
      }}
      width="100%"
      animationName={getAppValue({
        bibino: "motion-indicator.json",
        barkio:
          mode === "audio"
            ? "motion-indicator-red.json"
            : "motion-indicator-white.json"
      })}
    />
  );
}
